import { useRef, useState } from "react";
import useClickOutside from "../../hooks/useClickOutside";
import { getSecondsAndMinutes } from "../../utils/converters/time-helper";
import SvgIcon from "../SvgIcon";

const TimeSelector = ({
  onChange = () => {},
  restTime,
  initialOpen = false,
  label = "Custom rest time",
  tabIndex = -1,
}) => {
  const fieldsetRef = useRef(null);
  const [isListOpen, setIsListOpen] = useState(initialOpen);
  const [secs, mins] = getSecondsAndMinutes(restTime);
  const [minutes, setMinutes] = useState(mins);
  const [seconds, setSeconds] = useState(secs);

  useClickOutside(fieldsetRef, () => {
    setIsListOpen(false);
    onChange({
      target: { name: "restTime", value: seconds + minutes * 60 },
    });
  }, isListOpen);

  const handleMinutesChange = (value) => {
    if (!value && value !== 0) return setMinutes("");
    const newMinutes = parseInt(value, 10);

    if (Number.isNaN(newMinutes)) {
      setMinutes(0);
    }
    if (!Number.isNaN(newMinutes) && newMinutes >= 0 && newMinutes <= 60) {
      let newSeconds = seconds;
      setMinutes(newMinutes);

      if (newMinutes === 60) {
        newSeconds = 0;
        setSeconds(newSeconds);
      }
    }
  };

  const handleSecondsChange = (value) => {
    if (!value && value !== 0) return setSeconds("");
    const newSeconds = parseInt(value, 10);

    if (Number.isNaN(newSeconds)) {
      setSeconds(0);
    }

    if (!Number.isNaN(newSeconds) && newSeconds >= 0 && newSeconds <= 60) {
      if (minutes < 60 || (minutes === 60 && newSeconds === 0)) {
        setSeconds(newSeconds);
      }
    }
  };

  const toggleList = (e) => {
    e.preventDefault();
    setIsListOpen((prevState) => !prevState);
    onChange({
      target: { name: "restTime", value: seconds + minutes * 60 },
    });
  };

  return (
    <fieldset ref={fieldsetRef} className="time-selector">
      {!initialOpen && (
        <button
          onClick={toggleList}
          data-button-type="secondary"
          tabIndex={tabIndex}
          type="button"
        >
          <SvgIcon src="/img/svg/time.svg" />
        </button>
      )}
      {isListOpen && (
        <div className="time-selector-body">
          <label htmlFor="default-time-minutes" className="mb-0!">
            {label}
          </label>

          <div className="default-time-select-row">
            <div className="default-time-row">
              <input
                className="text-center"
                type="number"
                id="default-time-minutes"
                name="default-time-minutes"
                min="0"
                max="60"
                value={minutes}
                onChange={(e) => {
                  handleMinutesChange(e.target.value);
                }}
              />
              Min
            </div>
            <span className="time-separator">:</span>
            <div className="default-time-row">
              <input
                className="text-center"
                type="number"
                id="default-time-seconds"
                name="default-time-seconds"
                min="0"
                max="60"
                value={seconds}
                onChange={(e) => {
                  handleSecondsChange(e.target.value);
                }}
              />
              Sec
            </div>
          </div>
          <button data-button-type="primary" onClick={toggleList} type="button">
            Save
          </button>
        </div>
      )}
    </fieldset>
  );
};

export default TimeSelector;
